import Vue from "vue";
import { createPinia, defineStore, PiniaVuePlugin } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

Vue.use(PiniaVuePlugin);

export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const defaultAppTitle =
  "Баласка - программный комплекс автоматизации вывоза мусора";

const _useStore = defineStore("store", {
  persist: true,
  state() {
    return {
      app: {
        title: defaultAppTitle,
        side_menu_visible: true,
      },
      authorised: false,
      balance: undefined,
      user_info: {},
      form_options: {},
      layout: "default",
      pending_orders: { orders: [], params: {} },
      payed_orders: { orders: [], params: {} },
      messages: [],
      error_queue: [],
    };
  },
  getters: {
    staff() {
      let { userfio, usershort, postname, prov_name } = this.user_info;
      const items = [];
      if (postname) {
        items.push(postname);
      }

      if (prov_name) {
        items.push(prov_name);
      }

      if (items.length) {
        return `${usershort ?? userfio} (${items.join(", ")})`;
      }

      return userfio;
    },
    getFormOptions() {
      return (formname) => this.form_options[formname] || { itemsPerPage: 100 };
    },
  },
  actions: {
    setAppTitle(title) {
      this.app.title = title;
    },
    resetAppTitle() {
      this.setAppTitle(defaultAppTitle);
    },
    showSideMenu() {
      this.app.side_menu_visible = true;
    },
    hideSideMenu() {
      this.app.side_menu_visible = false;
    },
    logout() {
      this.setAuthorised(false);
    },
    setUserInfo(data) {
      let layout = data.rolename;
      if (!layout) {
        layout = "default";
      } else if (layout == "administrator" || layout == "supervisor") {
        layout = "dispatcher";
      }

      let { result, status, ...user_info } = data;

      this.layout = layout;
      this.user_info = user_info;
    },
    setBalance(balance) {
      this.balance = balance;
    },
    setAuthorised(value) {
      this.authorised = value;
      if (!value) {
        this.$reset();
      }
    },
    setFormOptions({ formname, options }) {
      if (!formname) {
        return;
      }
      if (!this.form_options[formname]) {
        this.form_options[formname] = {};
      }
      if (this.form_options[formname].itemsPerPage != options.itemsPerPage) {
        this.form_options[formname].itemsPerPage = options.itemsPerPage;
      }
    },
    setLayout(value) {
      this.layout = value;
    },
    setPendingOrders(pending_orders) {
      this.pending_orders = pending_orders;
    },
    setMessages(messages) {
      this.messages = messages;
    },
    setPayedOrders(payed_orders) {
      this.payed_orders = payed_orders;
    },
    postMessageQueue(message) {
      this.error_queue.push(message);
    },
  },
});

export const useStore = () => _useStore(pinia);
